import { ASSETS_GRAPH_DATA } from "constants/actionTypes";
import { ASSETS_FILTER_DATA, ASSET_DELETE } from "constants/types";
import { IAssetGraphData, IAssetGraphDataLoading, IAssetItem } from "../interfaces";

const assetsFiltersDataInitialState = {
  campaigns: [
    { label: "All Types", value: "all" },
    { label: "Ad hoc Emails", value: "adhoc" },
    { label: "Digest Emails", value: "digest" },
  ],
  dates: [
    { label: "All time", value: "all" },
    { label: "1 QTR", value: "qtr" },
    { label: "Month", value: "month" },
    { label: "Week", value: "week" },
    { label: "Day", value: "day" },
    { label: "Custom", value: "custom" },
  ],
  users: [{ label: "by User", value: "default" }] as any,
  data: Array<IAssetItem>(),
  loading: false,
  loadingUsers: false,
  isFiltered: false,
  paginationStatus: true,
  selectedAssetType: "all",
  selectedAssetTypeObject: { label: "All Types", value: "all" },
  selectedUser: "default",
  selectedUserObject: { label: "by User", value: "default" },
  selectedStartDate: "",
  selectedEndDate: "",
  selectedDatesObject: { label: "1 QTR", value: "qtr" },
  page: 0,
  articlesCount: 0,
};

export const assetsFiltersDataReducer = (state = assetsFiltersDataInitialState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case ASSETS_FILTER_DATA.RESET_ALL_FILTERS:
      newState.selectedAssetType = "all";
      newState.selectedAssetTypeObject = { label: "All Types", value: "all" };
      newState.selectedUser = "default";
      newState.selectedUserObject = { label: "by User", value: "default" };
      // newState.selectedDates = "qtr";
      newState.selectedDatesObject = { label: "1 QTR", value: "qtr" };
      newState.page = 0;
      newState.isFiltered = false;
      return newState;
    case ASSETS_FILTER_DATA.SUCCESS_USERS:
      newState.loading = false;
      newState.users = [...action.payload];
      return newState;
    case ASSETS_FILTER_DATA.LOAD_USERS:
      newState.loadingUsers = true;
      return newState;
    case ASSETS_FILTER_DATA.FAIL_USERS:
      newState.loadingUsers = false;
      return newState;
    case ASSETS_FILTER_DATA.SET_CAMPAIGN:
      // when a campaign filter is set then it will check for some other
      // configurations and change values accordingly
      // e.g. isFiltered will be true if campaign type filter is not set to 'all'
      if (action.payload.value !== "all" && !state.isFiltered) {
        newState.isFiltered = true;
      } else if (action.payload.value === "all" && state.selectedUser === "default") {
        newState.isFiltered = false;
        newState.loading = false;
      }
      if (action.payload.value !== state.selectedAssetType && action.payload.value !== "all") {
        newState.data = [];
        newState.page = 0;
        newState.articlesCount = 0;
        newState.loading = true;
      }
      newState.selectedAssetType = action.payload.value;
      newState.selectedAssetTypeObject = action.payload;
      return newState;

    case ASSETS_FILTER_DATA.SET_USER:
      // when a user filter is set then it will check for some other
      // configurations and change values accordingly
      // e.g. isFiltered will be true if user filter is not set to 'default'
      if (action.payload.value !== "default" && !state.isFiltered) {
        newState.isFiltered = true;
      } else if (action.payload.value === "default" && state.selectedAssetType === "all") {
        newState.isFiltered = false;
        newState.loading = false;
      }
      if (action.payload.value !== state.selectedUser && action.payload.value !== "default") {
        newState.data = [];
        newState.page = 0;
        newState.articlesCount = 0;
        newState.loading = true;
      }
      newState.selectedUser = action.payload.value;
      newState.selectedUserObject = action.payload;
      return newState;

    case ASSETS_FILTER_DATA.SET_DATE:
      newState.selectedStartDate = action.start_date;
      newState.selectedEndDate = action.end_date;
      newState.selectedDatesObject = action.payload;
      return newState;

    case ASSETS_FILTER_DATA.LOAD:
      newState.loading = true;
      return newState;
    case ASSETS_FILTER_DATA.SUCCESS:
      const { payload } = action;
      newState.loading = false;
      newState.page = newState.page + 1;
      newState.articlesCount = state.articlesCount + action.payload.length;
      newState.data = [...state.data, ...action.payload];
      if (newState.page > 1 && payload?.length === 0) {
        newState.paginationStatus = false;
      } else if (payload?.length < 10) {
        newState.paginationStatus = false;
      } else {
        newState.paginationStatus = true;
      }

      return newState;
    case ASSETS_FILTER_DATA.FAIL:
      newState.loading = false;
      return newState;

    case ASSETS_FILTER_DATA.RESET:
      return assetsFiltersDataInitialState;

    case ASSET_DELETE.SUCCESS:
      let data = [...state.data];
      let newData = data;
      newData.splice(action.payload, 1);
      newState.data = [...newData];
      return newState;

    default:
      return state;
  }
};

const initialAssetGraphDataState: IAssetGraphDataLoading = {
  loading: false,
  data: {},
  startDate: "",
  endDate: "",
};
interface IAssetGraphDataAction {
  type: string;
  payload: IAssetGraphData;
  start_date?: string;
  end_date?: string;
  user_id?: string;
}
export const assetGraphReducer = (
  state: IAssetGraphDataLoading = initialAssetGraphDataState,
  action: IAssetGraphDataAction
) => {
  const newState: IAssetGraphDataLoading = { ...state };
  switch (action.type) {
    case ASSETS_GRAPH_DATA.LOAD_SUCCESS:
      newState.loading = false;
      newState.data = { ...state.data, ...action.payload };
      return newState;

    case ASSETS_GRAPH_DATA.LOAD:
      newState.loading = true;
      newState.data = {};
      return newState;

    case ASSETS_GRAPH_DATA.LOAD_FAIL:
      newState.loading = false;
      newState.data = {};
      return newState;

    case ASSETS_GRAPH_DATA.SET_DATES:
      if (action.start_date && action.end_date) {
        newState.startDate = action.start_date;
        newState.endDate = action.end_date;
      }
      return newState;

    case ASSETS_GRAPH_DATA.SET_USER:
      if (action.user_id) newState.userId = action.user_id;
      return newState;

    case ASSETS_GRAPH_DATA.CLEAR:
      return initialAssetGraphDataState;

    default:
      return state;
  }
};
